import { Container } from "@mantine/core";
import React from "react";
import { BsArrowRight } from "react-icons/bs";

const About = () => {
  return (
    <>
      <Container>
        <div className="flex justify-center items-center my-20 gap-20 flex-col lg:flex-row">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FRectangle%2052.png?alt=media&token=4e7840ca-2047-45d7-82e3-950b0fa1b964"
            alt=""
            className="w-72"
          />
          <div className="">
            <p className="tracking-wider leading-8 text-[#737373]">
              LOUVRE caters to thoughtful shoppers who appreciate unique designs
              and top quality.LOUVRE caters to thoughtful shoppers who
              appreciate unique designs and top quality.
            </p>
            <button className="flex items-center uppercase gap-2 font-bold text-xs mt-5">
              <span className=" text-gray-500">see more</span> <BsArrowRight />
            </button>
          </div>
        </div>
      </Container>
      {/* <Container>
        <div className="flex flex-col justify-center items-center gap-5">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FRectangle%2052.png?alt=media&token=4e7840ca-2047-45d7-82e3-950b0fa1b964"
            alt=""
            className="w-52"
          />
          <div className="">
            <p className="tracking-wider leading-8 text-[#737373]">
              LOUVRE caters to thoughtful shoppers who appreciate unique designs
              and top quality.LOUVRE caters to thoughtful shoppers who
              appreciate unique designs and top quality.
            </p>
            <button className="flex items-center uppercase gap-2 font-bold text-xs mt-5">
              <span className=" text-gray-500">see more</span> <BsArrowRight />
            </button>
          </div>
        </div>
      </Container> */}
    </>
  );
};

export default About;
